module.exports = __webpack_public_path__ + "img/PizzaMasterLogo.1cb9f92f.png";